import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff5d3e6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "creat-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "mian-content" }
const _hoisted_4 = { class: "send-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "通知内容", -1))
const _hoisted_6 = { class: "send-container" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "image-tips" }, "请上传5MB以内的.jpg/.jpeg/.gif/.png文件", -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iconfont icon-daochu upload-file" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips" }, "仅支持上传pdf文件", -1))
const _hoisted_14 = { class: "send-person" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "发送对象", -1))
const _hoisted_16 = { class: "person-container" }
const _hoisted_17 = { class: "left" }
const _hoisted_18 = { class: "area" }
const _hoisted_19 = { class: "table" }
const _hoisted_20 = { class: "right" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请核对下发对象", -1))
const _hoisted_22 = { class: "right-container" }
const _hoisted_23 = { class: "company" }
const _hoisted_24 = { class: "company-person" }
const _hoisted_25 = { class: "sub-title" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Item = _resolveComponent("Item")!
  const _component_Col = _resolveComponent("Col")!
  const _component_Row = _resolveComponent("Row")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Tree = _resolveComponent("Tree")!
  const _component_Table = _resolveComponent("Table")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
      }, "新建通知"),
      _createElementVNode("div", {
        class: "back-to",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
      }, "返回")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "formRef",
            model: _ctx.formState,
            rules: _ctx.rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, {
                        ref: "title",
                        label: "工单标题",
                        name: "title"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Input, {
                            placeholder: "请输入标题",
                            value: _ctx.formState.title,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.title) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Col, { span: 1 })
                ]),
                _: 1
              }),
              _createVNode(_component_Row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, {
                        label: "工单描述",
                        name: "describetion"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_TextArea, {
                            placeholder: "请输入工单描述",
                            value: _ctx.formState.describetion,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.describetion) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_Row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, { label: "上传图片" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Upload, {
                            action: `${_ctx.serverIp}/file/upLoadFile`,
                            "list-type": "picture-card",
                            "file-list": _ctx.imgList,
                            beforeUpload: _ctx.beforeImgUpload,
                            remove: _ctx.handleImgRemove,
                            onPreview: _ctx.handlePreview,
                            onChange: _ctx.handleImgChange,
                            accept: ".jpg,.jpeg,.gif,.png"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.imgList.length < 9)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["action", "file-list", "beforeUpload", "remove", "onPreview", "onChange"]),
                          _hoisted_10,
                          _createVNode(_component_a_modal, {
                            visible: _ctx.previewVisible,
                            footer: null,
                            onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.previewVisible = false))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                alt: "example",
                                style: {"width":"100%"},
                                src: _ctx.previewImage
                              }, null, 8, _hoisted_11)
                            ]),
                            _: 1
                          }, 8, ["visible"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_Row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, {
                        name: "textFileList",
                        label: "上传附件"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Upload, {
                            action: `${_ctx.serverIp}/file/upLoadFile`,
                            "file-list": _ctx.textFileList,
                            multiple: false,
                            accept: ".pdf",
                            beforeUpload: _ctx.beforeTextUpload,
                            remove: _ctx.handleTextRemove,
                            onChange: _ctx.handleTextChange
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["action", "file-list", "beforeUpload", "remove", "onChange"]),
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_Tree, {
                "tree-data": _ctx.list,
                selectedKeys: _ctx.selectedTreeKeys,
                "onUpdate:selectedKeys": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTreeKeys) = $event)),
                expandedKeys: _ctx.expandData,
                "onUpdate:expandedKeys": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.expandData) = $event)),
                onSelect: _ctx.handleSelect
              }, null, 8, ["tree-data", "selectedKeys", "expandedKeys", "onSelect"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
                default: _withCtx(() => [
                  _createVNode(_component_Table, {
                    columns: _ctx.columns,
                    scroll: {
                    y: '4.2rem'
                  },
                    pagination: false,
                    "data-source": _ctx.tableData,
                    "row-selection": _ctx.rowSelection
                  }, null, 8, ["columns", "scroll", "data-source", "row-selection"])
                ]),
                _: 1
              }, 8, ["locale"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("ul", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.selectedRowsObj), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "right-item",
                  key: item
                }, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(item), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.streetTiltle(_ctx.selectedRowsObj[item])), 1),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedRowsObj[item], (i, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "name-item",
                          key: i
                        }, [
                          _createElementVNode("div", null, _toDisplayString(i), 1),
                          _createElementVNode("div", {
                            class: "iconfont icon-guanbi",
                            onClick: ($event: any) => (_ctx.delPerson(index, item, i))
                          }, null, 8, _hoisted_26)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", {
        class: "reset-btn",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
      }, "重置"),
      _createElementVNode("div", {
        class: "send-btn",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.sendNotice && _ctx.sendNotice(...args)))
      }, "发送")
    ])
  ]))
}